var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgStarFlight2Cfcfa74 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4956 2.32043C11.6344 1.89319 12.2389 1.89319 12.3777 2.32043L14.4354 8.65334C14.4975 8.84441 14.6755 8.97377 14.8764 8.97377H21.5354C21.9846 8.97377 22.1714 9.54861 21.808 9.81266L16.4208 13.7266C16.2582 13.8447 16.1902 14.054 16.2523 14.2451L18.31 20.578C18.4488 21.0052 17.9598 21.3605 17.5964 21.0965L12.2092 17.1825C12.0467 17.0644 11.8266 17.0644 11.6641 17.1825L6.28502 21.0905C5.92307 21.3535 5.43723 21.0023 5.56943 20.5783C5.57107 20.573 5.57237 20.5693 5.57429 20.5641C5.63429 20.403 6.85708 17.1429 8 16C9.5 14.5 11.5405 12.8185 14.8764 11.5658C15.3076 11.4038 15.0809 10.9052 14.6522 11.0363C11.5 12 8.23901 11.9431 6.5 11.5C4.92787 11.0994 2.52308 9.97318 2.23829 9.83858C2.21943 9.82967 2.20136 9.81981 2.18463 9.80734C1.83346 9.54553 2.01448 8.97377 2.46458 8.97377H8.99685C9.19775 8.97377 9.37581 8.84441 9.43789 8.65334L11.4956 2.32043Z",
    fill: "url(#paint0_linear_169_2672)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_2672",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 21.1871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStarFlight2Cfcfa74);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "svg/sad8mtk42pgn.svg";